<script>
    export default {
        name: "PlainPage",
    };
</script>


<template>
    <div class="plain-page">
        <header>
            <div class="contents">
                <slot name="header" />
            </div>
        </header>
        <div class="contents">
            <slot />
        </div>

        <Footer>
            <div class="contents">
                <slot name="footer" />
            </div>
        </Footer>
    </div>
</template>


<style lang="scss">
    .plain-page {
        display: flex;
        flex-direction: column;
        height: 100%;

        .contents {
            max-width: 900px;
            width: 100%;
            margin: 0 auto;
            padding: 0 80px;
            line-height: 150%;
        }

        header {
            background: $lockbox-bg;
            padding: 50px 0;

            h1 {
                font-family: $header-font;
                font-weight: 900;
                font-size: 36px;
                line-height: 120%;
                margin: 0;
            }

            .tagline {
                font-family: $main-font;
                margin: 24px 0;
                line-height: 200%;
            }
        }

        section {
            font-size: 18px;
            margin: 80px 0;

            h1 {
                font-family: $header-font;
                font-weight: 800;
                font-size: 24px;
            }

            p {
                line-height: 200%;
                margin: 0;

                &:not(:first-of-type) {
                    margin-top: 1em;
                }
            }

            li {
                line-height: 200%;
            }
        }
    }

    @media (max-width: $mobile-break) {
        .plain-page {
            header {
                padding-top: 30px;

                h1 {
                    font-size: 28px;
                }

                .tagline {
                    margin-top: 0;
                }
            }

            .contents {
                padding: 0 30px;
            }

            section:last-child {
                margin-bottom: 30px;
            }

        }
    }
</style>

